// extracted by mini-css-extract-plugin
export var errorBanner = "_kq-2";
export var scroller = "_kq-0";
export var thinking = "_kq-1";
export var visuallyHidden = "_kq-3";